var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-datepicker',{attrs:{"icon":"calendar","editable":"","trap-focus":"","first-day-of-week":1,"nearby-selectable-month-days":"","minDate":_vm.minDate,"maxDate":_vm.maxDate},on:{"input":function($event){return _vm.updateValue()}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }